export default "__VITE_ASSET__BduPuQDn__"